import { round } from "lodash";

export default function calcularRiscoReprovacao(mediaHumanas, mediaLinguagens, mediaMatematica, mediaNatureza) {
    let mediaMaiorQueZero = 0;
    let numeroNotasMaiorQueZero = 0;
    if(mediaHumanas > 0) {
        mediaMaiorQueZero += mediaHumanas;
        numeroNotasMaiorQueZero++;
    }

    if(mediaLinguagens > 0) {
        mediaMaiorQueZero += mediaLinguagens;
        numeroNotasMaiorQueZero++;
    }

    if(mediaMatematica > 0) {
        mediaMaiorQueZero += mediaMatematica;
        numeroNotasMaiorQueZero++;
    }

    if(mediaNatureza > 0) {
        mediaMaiorQueZero += mediaNatureza;
        numeroNotasMaiorQueZero++;
    }
    

    if(numeroNotasMaiorQueZero > 0) {
        return round(mediaMaiorQueZero / numeroNotasMaiorQueZero, 0);
    } else {
        return 0
    }

}
    